
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import echarts from "echarts"  //先引入echarts
    import hebeishengJson from "@/assets/json/mapjson/130000.json"
    import shijiazhuangshi from '@/assets/json/mapjson/shijiazhuangshi.json';  //石家庄
    import tangshanshi from '@/assets/json/mapjson/tangshanshi.json'  //唐山市
    import qinhuangdaoshi from '@/assets/json/mapjson/qinhuangdaoshi.json'  //秦皇岛市
    import handanshi from '@/assets/json/mapjson/handanshi.json'  //邯郸市
    import xingtaishi from '@/assets/json/mapjson/xingtaishi.json'  //邢台市
    import baodingshi from '@/assets/json/mapjson/baodingshi.json'  //保定市
    import zhangjiakoushi from '@/assets/json/mapjson/zhangjiakoushi.json'  //张家口市
    import chengdeshi from '@/assets/json/mapjson/chengdeshi.json'  //承德市
    import cangzhoushi from '@/assets/json/mapjson/cangzhoushi.json'  //沧州市
    import langfangshi from '@/assets/json/mapjson/langfangshi.json'  //廊坊市
    import hengshuishi from '@/assets/json/mapjson/hengshuishi.json'
    import {standardPublicApi} from "@/api/standard";
    import {authorizeCertApi, dictApi} from "@/api/organization";  //衡水市
    const {CodeToText, regionData} =require("@/js/region/region");

    @Component({
        name: "Maps",
    })
    export default class Map extends Vue {
        title = "";
        loading = false;
        mapJson = "" as any;
        mapData = "";
        cityCode = "";
        cityName = "";
        cityMap = {
            "石家庄市": shijiazhuangshi,
            "唐山市": tangshanshi,
            "秦皇岛市": qinhuangdaoshi,
            "邯郸市": handanshi,
            "邢台市": xingtaishi,
            "保定市": baodingshi,
            "张家口市": zhangjiakoushi,
            "承德市": chengdeshi,
            "沧州市": cangzhoushi,
            "廊坊市": langfangshi,
            "衡水市": hengshuishi
        } as any;
        mapOption = {} as any;
        mapChart = "" as any;
        barOption = {} as any;
        barChart = "" as any;
        barData = {
            nameArr: [] as any,
            dataArr: [] as any,
            maxNum : 0,
        }
        type = "0";  //type 0社会公用计量标准 1授权证书
        tableList = [
            {}
        ];
        mechanismTypeList = [];
        CodeToText = CodeToText;
        tableAlign = "left";
        colorArr = [['#1268f3','#08a4fa','#01ccfe'],['#FF8209','#FFA31F','#ffc837'],['#ef3b36','#F57E7B','#F9B2B0']]
        legend = ['在用', '暂停', '封存'];


        mounted() {
            this.type = this.$route.params.type;
            this.title = this.type=="1"?'授权项目':'社会公用计量标准';
            this.listDict();
            this.getData(0);
            // this.getJson();
        }
        getData(code: number){
            this.loading = true;
            let api;
            const params = {code: code?code:'130000'};
            if(this.type == "1"){
                api = authorizeCertApi.regionToAuthorizeCert(params)
            }else{
                api = standardPublicApi.regionToStandardPublic(params)
            }
            api.then((r: any) => {
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    console.log(rData)
                    const nameArr = [] as any;
                    const dataArr = [[],[],[]] as any;
                    const allData = {
                        name: "合计",
                        number: 0,
                        useNumber: 0,
                        sealedNumber: 0,
                        stopNumber: 0,

                        number1: 0,
                        useNumber1: 0,
                        sealedNumber1: 0,
                        stopNumber1: 0,

                        number2: 0,
                        useNumber2: 0,
                        sealedNumber2: 0,
                        stopNumber2: 0,

                        number3: 0,
                        useNumber3: 0,
                        sealedNumber3: 0,
                        stopNumber3: 0,
                    }
                    let maxNum = 0;
                    rData.map((item:any,index: number) => {
                        item.index = index+1;
                        allData.number += item.number;
                        allData.useNumber += item.useNumber;
                        allData.sealedNumber += item.sealedNumber;
                        allData.stopNumber += item.stopNumber;
                        nameArr.push(item.name);
                        dataArr[0].push(item.useNumber);
                        dataArr[1].push(item.stopNumber);
                        dataArr[2].push(item.sealedNumber);
                        const numAll = item.useNumber + item.stopNumber + item.sealedNumber;
                        if(maxNum < numAll) maxNum = numAll;

                        item.standardSummaries.map((item2: any) => {
                            if(item2.level == "0001"){
                                allData.number1 += item2.number;
                                allData.useNumber1 += item2.useNumber;
                                allData.sealedNumber1 += item2.sealedNumber;
                                allData.stopNumber1 += item2.stopNumber;
                                if(!item.number1) item.number1 = 0;
                                if(!item.useNumber1) item.useNumber1 = 0;
                                if(!item.sealedNumber1) item.sealedNumber1 = 0;
                                if(!item.stopNumber1) item.stopNumber1 = 0;
                                item.number1 += item2.number;
                                item.useNumber1 += item2.useNumber;
                                item.sealedNumber1 += item2.sealedNumber;
                                item.stopNumber1 += item2.stopNumber;
                                item2.number1 = item2.number;
                                item2.useNumber1 = item2.useNumber;
                                item2.sealedNumber1 = item2.sealedNumber;
                                item2.stopNumber1 = item2.stopNumber;
                            }else if(item2.level == "0002"){
                                allData.number2 += item2.number;
                                allData.useNumber2 += item2.useNumber;
                                allData.sealedNumber2 += item2.sealedNumber;
                                allData.stopNumber2 += item2.stopNumber;
                                if(!item.number2) item.number2 = 0;
                                if(!item.useNumber2) item.useNumber2 = 0;
                                if(!item.sealedNumber2) item.sealedNumber2 = 0;
                                if(!item.stopNumber2) item.stopNumber2 = 0;
                                item.number2 += item2.number;
                                item.useNumber2 += item2.useNumber;
                                item.sealedNumber2 += item2.sealedNumber;
                                item.stopNumber2 += item2.stopNumber;
                                item2.number2 = item2.number;
                                item2.useNumber2 = item2.useNumber;
                                item2.sealedNumber2 = item2.sealedNumber;
                                item2.stopNumber2 = item2.stopNumber;
                            }else if(item2.level == "0003"){
                                allData.number3 += item2.number;
                                allData.useNumber3 += item2.useNumber;
                                allData.sealedNumber3 += item2.sealedNumber;
                                allData.stopNumber3 += item2.stopNumber;
                                if(!item.number3) item.number3 = 0;
                                if(!item.useNumber3) item.useNumber3 = 0;
                                if(!item.sealedNumber3) item.sealedNumber3 = 0;
                                if(!item.stopNumber3) item.stopNumber3 = 0;
                                item.number3 += item2.number;
                                item.useNumber3 += item2.useNumber;
                                item.sealedNumber3 += item2.sealedNumber;
                                item.stopNumber3 += item2.stopNumber;
                                item2.number3 = item2.number;
                                item2.useNumber3 = item2.useNumber;
                                item2.sealedNumber3 = item2.sealedNumber;
                                item2.stopNumber3 = item2.stopNumber;
                            }
                        })
                    })
                    dataArr[0].reverse();
                    dataArr[1].reverse();
                    dataArr[2].reverse();
                    this.barData.nameArr = nameArr.reverse();
                    this.barData.dataArr = dataArr;
                    this.barData.maxNum = maxNum;
                    this.modulationJson(rData);
                    this.tableList = [allData, ...rData];
                }
            })
        }
        listDict() {
            //单位类别
            dictApi.listDictItem({typeCode: "dwlb"}).then((r) => {
                if (r.data.result === 0) {
                    const mechanismTypeData = {} as any;
                    const dataList = r.data.data;
                    this.mechanismTypeList = dataList;
                }
            });
        }
        listTypeName(ids:string){
            const arr = ids?ids.split(","):[];
            const arr2 = [] as any;
            arr.forEach((e:any)=>{
                const obj = this.mechanismTypeList.find((e2:any)=>e2.dictKey == e) as any;
                if(obj){
                    arr2.push(obj.dictValue);
                }
            })
            return arr2.length>0?arr2.join(","):"-";
        }
        //在<table>里，我们已经设置row的key值设置为每行数据id：row-key="id"
        rowClick(row: any, event: any, column: any) {
            let $table = this.$refs.table as HTMLFormElement;
            this.tableList.map((item:any) => {
                if (row.id != item.id) {
                    $table.toggleRowExpansion(item, false)
                }
            })
            $table.toggleRowExpansion(row)
        }
        modulationJson(rData: any){
            this.mapJson = this.cityName?this.cityMap[this.cityName]:hebeishengJson;
            this.mapData = this.mapJson.features.map((item:any) => {
                let value = 0;
                const obj = rData.find((e:any)=>e.code == item.properties.adcode);
                if(obj){
                    value = obj.number;
                }
                return ({
                    name: item.properties.name,
                    value: value,
                    level: item.properties.level,
                    cityCode: item.properties.adcode
                })
            })
            if(this.mapChart){
                this.changeMapEcharts();
            }else{
                this.init()//调用下面的 echarts初始化
            }
            this.loading = false;
        }
        //改变地图数据
        changeMapEcharts(){
            if(this.cityName){
                echarts.registerMap(this.cityName, this.mapJson, {});
            }else{
                echarts.registerMap('aaa',this.mapJson,{});  //加载自定义边界数据地图
            }

            // 找到属性名
//             let tmp = ''
//             Object.keys(this.mapChart._componentsMap).map((item) => {
//                 if (item.indexOf('series') !== -1 && item.indexOf('_toolbox') !== -1) {
//                     tmp = item
//                 }
//             })
// // 手动触发 back 事件
//             console.log(tmp)
//             if (this.mapChart._componentsMap[tmp]._features) {
//                 this.mapChart._componentsMap[tmp]._features.dataZoom.onclick(null, null, 'back')
//             }

            this.mapOption.series[0].data = this.mapData;
            console.log(this.mapOption)
            this.mapChart.setOption(this.mapOption, true);

            this.barOption.yAxis.data = this.barData.nameArr;
            this.barOption.xAxis.max = this.barData.maxNum;
            this.barOption.series = this.setBarSeries();
            this.barChart.setOption(this.barOption, true);
        }
        setBarSeries(){
            const arr = [];
            for(let i = 0;i < 3;i++){
                arr.push({
                    name: this.legend[i],
                    type: 'bar',
                    stack: '总量',
                    data: this.barData.dataArr[i],
                    //设置柱状图渐变颜色
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [{
                                offset: 0,
                                color: this.colorArr[i][0] // 0% 处的颜色
                            }, {
                                offset: 0.6,
                                color: this.colorArr[i][1] // 60% 处的颜色
                            }, {
                                offset: 1,
                                color: this.colorArr[i][2] // 100% 处的颜色
                            }], false)
                        },
                    },
                    barWidth: 20,
                    label: {
                        show: false, //开启显示
                        position: 'insideRight', //在上方显示
                        textStyle: { //数值样式
                            color: '#fff',
                            fontSize: 16
                        },
                        formatter:function (params:any) {
                            if(params.value==0){  //为0时不显示
                                return ''
                            }else{
                                return params.value
                            }
                        }
                    }
                })
            }
            return arr;
        }
        init(){
            const map = document.getElementById('map') as HTMLInputElement;
            const myChart = this.mapChart = echarts.init(map);
            echarts.registerMap('cityMap',this.mapJson,{});  //加载自定义边界数据地图
            const option = {
                // backgroundColor:'#04222e',// 背景颜色
                tooltip: {
                    trigger: 'item',
                    formatter: (p:any) => {
                        let val = p.value;
                        if (window.isNaN(val)) {
                            val = 0;
                        }
                        let txtCon =
                            "<div'> 地区：" + p.name + "<br/>数量：" + val + '</div>';
                        return txtCon;
                    }
                },
                series: [
                    {
                        zoom: 1.2, //当前视角的缩放比例
                        roam: true, //是否开启平游或缩放
                        scaleLimit: { //滚轮缩放的极限控制
                            min: 1,
                            max: 3
                        },
                        name: '地图',
                        type: 'map',
                        mapType: 'cityMap',
                        itemStyle: {
                            normal: {
                                show: true,
                                // areaColor:'#031525', //地图区域的颜色 也可以颜色渐变如下的 areaColor
                                areaColor:{
                                    type: 'radial',
                                    x: 0.5,
                                    y: 0.5,
                                    r: 0.8,
                                    colorStops: [{
                                        offset: 0,
                                        color: 'rgba(147, 235, 248, 0)' // 0% 处的颜色
                                    }, {
                                        offset: 1,
                                        color: 'rgba(147, 235, 248, .5)' // 100% 处的颜色
                                    }],
                                    globalCoord: false // 缺省为 false
                                },
                                borderColor: '#0CD5DD', //边界线颜色
                                borderWidth: '1', //边界线的宽度
                            },
                            emphasis: { // 鼠标移入时区域的样式
                                areaColor: '#2AB8FF',
                                borderWidth: 0,
                                color: 'green'
                            }
                        },
                        label: {
                            normal: {
                                show: true,
                                textStyle: {
                                    color: '#000'  //省市区字体颜色
                                },
                                formatter: function(params: any) {
                                    return "{a|"+params.name+"}\n{b|"+params.data.value+"}"
                                },
                                rich: {
                                    a: {
                                        color: '#0066CC',
                                        lineHeight: 25
                                    },
                                    b: {
                                        fontSize: 16,
                                        fontFamily: 'Microsoft YaHei',
                                        borderColor: '#00CCCC',
                                        borderRadius: 4
                                    }
                                }
                            },
                            emphasis: {//对应的鼠标悬浮效果
                                show: true,
                                textStyle: {
                                    color: '#333'  //鼠标移入对应的省市区字体颜色
                                }
                            },

                        },
                        data: this.mapData   // 上面添加了 name,value,level,cityCode的数据
                    }
                ]
            }
            this.mapOption = option;

            myChart.setOption(option,true);
            myChart.on("click",(params:any)=>{
                if(params.data.level == "district"){
                    this.toList(params.data.cityCode,params.name)
                }else{
                    option.series[0].mapType = params.name;
                    this.cityCode = params.data.cityCode;
                    this.cityName = params.name;
                    this.getData(params.data.cityCode);
                }
            })


            const bar = document.getElementById('bar') as HTMLInputElement;
            const barChart = this.barChart = echarts.init(bar);
            const option2 = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    data: this.legend
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    boundaryGap: [0, 0.01],
                    minInterval: 1,
                    max: this.barData.maxNum
                },
                yAxis: {
                    type: 'category',
                    data: this.barData.nameArr
                },
                series: this.setBarSeries()
            };
            this.barOption = option2;
            barChart.setOption(option2)
        }
        //返回省
        returnProvince(){
            this.mapOption.series[0].mapType = "cityMap";
            this.cityCode = "";
            this.cityName = "";
            this.getData(0);
        }
        //进入列表页
        toList(code: string,name:string){
            let code2 = code;
            let name2 = name;
            if(!code){
                code2 = this.cityCode;
                name2 = this.cityName;
            }
            if(this.type == "1"){//授权证书
                // const routeData = this.$router.resolve("/mapList2?code="+code2+"&codeName="+name2);
                // window.open(routeData.href, '_blank');
                this.$router.push("/statistics/mapList2?code="+code2+"&codeName="+name2);
            }else{
                // const routeData = this.$router.resolve("/mapList?code="+code2+"&codeName="+name2);
                // window.open(routeData.href, '_blank');
                this.$router.push("/statistics/mapList?code="+code2+"&codeName="+name2);
            }
        }
    }
